<template>
  <div class="cascadas">

    <!-- ============ HERO ============ -->
    <header class="hero">
      <div class="hero__bg" role="img" aria-label="Sendero y río en Las Cascadas, Villa del Carbón">
        <!-- Sustituir por foto real del lugar (bosque / río / cascadas) -->
      </div>
      <div class="hero__contour" aria-hidden="true"></div>
      <div class="hero__vignette" aria-hidden="true"></div>

      <div class="hero__frame">
        <span class="hero__brand">XHIDENXI</span>

        <div class="hero__stamp">
          <svg viewBox="0 0 120 120" class="hero__stamp-ring" aria-hidden="true">
            <circle cx="60" cy="60" r="56" />
          </svg>
          <svg viewBox="0 0 64 64" class="hero__stamp-icon" aria-hidden="true">
            <path d="M32 4c9 0 14 6 14 13 0 6-3 9-3 14 0 9 7 11 7 20 0 7-6 9-11 9-4 0-6-3-6-7 0-5 3-6 3-11 0-4-2-6-6-6s-6 2-6 6c0 5 3 6 3 11 0 4-2 7-6 7-5 0-11-2-11-9 0-9 7-11 7-20 0-5-3-8-3-14C13 10 18 4 32 4z"/>
          </svg>
          <span class="hero__stamp-text">5K&nbsp;·&nbsp;10K</span>
        </div>

        <h1 class="hero__title">RETO ENTRE<br>CASCADAS</h1>
        <p class="hero__subtitle">Carrera Trail &mdash; entre senderos, naturaleza y cascadas</p>

        <div class="hero__meta">
          <span class="hero__date">13&nbsp;·&nbsp;DIC&nbsp;·&nbsp;2026</span>
          <span class="hero__divider" aria-hidden="true"></span>
          <span class="hero__place">Las Cascadas, Villa del Carbón, Edo. Méx.</span>
        </div>
      </div>

      <a href="#reto" class="hero__scroll">
        <span>Descubre el reto</span>
        <svg viewBox="0 0 24 24" width="16" height="16"><path d="M12 4v16m0 0l-6-6m6 6l6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </a>
    </header>

    <!-- ============ MISIÓN ============ -->
      <!-- Información general -->
        <div class="text-center mt-5">
            <img src="@/assets/images/logo_principal.png" class="imgBanner img-fluid" alt="logo" width="180">
        </div>

    <section id="reto" class="mission">
      <p class="mission__text">
        Prepárate para recorrer senderos entre bosque y agua, cruzar un puente colgante
        y llegar a meta rodeado de cascadas. Una carrera trail para quienes buscan
        naturaleza de verdad.
      </p>
    </section>

    <!-- ============ TARJETA / PERMISO DE RUTA ============ -->
    <section class="permit-wrap">
      <div class="permit">
        <div class="permit__stub">
          <span class="permit__stub-label">PASE DE</span>
          <span class="permit__stub-value">CORREDOR</span>
        </div>

        <div class="permit__body">
          <h2 class="permit__title">RETO ENTRE CASCADAS 2026</h2>

          <dl class="permit__grid">
            <div class="permit__item">
              <dt>Fecha</dt>
              <dd>Domingo 13 de diciembre, 2026</dd>
            </div>
            <div class="permit__item">
              <dt>Sede</dt>
              <dd>Las Cascadas, Villa del Carbón</dd>
            </div>
            <div class="permit__item">
              <dt>Distancias</dt>
              <dd>5&nbsp;KM &amp; 10&nbsp;KM</dd>
            </div>
            <div class="permit__item">
              <dt>Salida</dt>
              <dd>8:00 / 8:10&nbsp;a.m.</dd>
            </div>
          </dl>

          <button class="btn btn--dark permit__cta" type="button" @click="irARegistro" :disabled="inscripcionesCerradas">
            {{ inscripcionesCerradas ? 'REGISTRO FINALIZADO' : 'QUIERO CORRER' }}
          </button>
        </div>
      </div>
    </section>

    <!-- ============ UBICACIÓN ============ -->
    <section class="location">
      <div class="location__wrap">
        <div class="location__info">
          <span class="tag tag--light">¿Dónde será el reto?</span>
          <h2 class="location__title">LAS CASCADAS</h2>

          <div class="location__details">
            <div class="location__row">
              <h3>Ubicación</h3>
              <p>Las Cascadas &mdash; Villa del Carbón, Edo. Méx.</p>
              <p class="location__ref">Carretera Chapa &ndash; Villa del Carbón</p>
            </div>
            <div class="location__row">
              <h3>Fecha y salida</h3>
              <p>Domingo 13 de diciembre, 2026</p>
              <p class="location__ref">5K 8:00 a.m. &nbsp;·&nbsp; 10K 8:10 a.m.</p>
            </div>
          </div>

          <a href="https://maps.app.goo.gl/Kh9BFjXs27BP3ECj6?g_st=ic" target="_blank" class="btn btn--outline-light">¿Cómo llegar?</a>
        </div>

        <div class="location__map">
          <div class="location__map-frame" @click="openGoogleMaps">
            <img src="@/assets/images/mapa-cascadas.png" alt="Mapa Rancho Don Mundo" class="map-image" />
            <div class="location__map-overlay">
              <span>VER EN GOOGLE MAPS</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ SALIDAS / DISTANCIAS ============ -->
    <section class="starts">
      <span class="tag tag--dark">Distancias y salidas</span>
      <div class="starts__row">
        <div class="marker" v-for="s in salidas" :key="s.km">
          <div class="marker__post">
            <span class="marker__km">{{ s.km }}</span>
          </div>
          <span class="marker__time">{{ s.hora }}</span>
          <span class="marker__label">SALIDA</span>
        </div>
      </div>
      <p class="starts__note">Supera una ruta de senderos, bosque y cruces de agua diseñada para poner a prueba tu resistencia.</p>
    </section>

    <!-- ============ CATEGORÍAS + PREMIACIÓN ============ -->
    <section class="prizes">
      <div class="prizes__wrap">
        <div class="prizes__categories">
          <h2 class="title-accent title-accent--light">Categorías</h2>
          <p class="prizes__sub">Disponibles en ambas distancias (5K y 10K)</p>
          <div class="chips">
            <span class="chip">Libre Varonil</span>
            <span class="chip">Libre Femenil</span>
          </div>
          <p class="prizes__foot">🥇🥈🥉 Se premian los 3 primeros lugares de cada categoría y distancia.</p>
        </div>

        <div class="prizes__seal">
          <svg viewBox="0 0 200 200" class="prizes__seal-ring" aria-hidden="true">
            <circle cx="100" cy="100" r="92"/>
            <circle cx="100" cy="100" r="80"/>
          </svg>
          <span class="prizes__seal-amount">$10,000</span>
          <span class="prizes__seal-label">Bolsa de<br>premiación</span>
        </div>
      </div>
    </section>

    <!-- ============ KIT DEL CORREDOR (pase / ticket) ============ -->
    <section class="kit">
      <div class="kit__wrap">
        <span class="tag tag--dark">Tu inscripción incluye</span>
        <h2 class="kit__title">KIT DEL CORREDOR</h2>

        <div class="kit__ticket">
          <div class="kit__ticket-notch kit__ticket-notch--left" aria-hidden="true"></div>
          <div class="kit__ticket-notch kit__ticket-notch--right" aria-hidden="true"></div>

          <ul class="kit__list">
            <li v-for="item in kitItems" :key="item">
              <svg viewBox="0 0 24 24" width="16" height="16"><path d="M4 12l5 5L20 6" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </section>

    <!-- ============ FASES DE INSCRIPCIÓN ============ -->
    <section class="phases">
      <span class="tag tag--dark">Fases de inscripción</span>
      <h2 class="phases__title">ENTRE MÁS PRONTO, MEJOR PRECIO</h2>

      <div class="phases__row">
        <div
          class="phase-card"
          v-for="(fase, i) in fases"
          :key="fase.nombre"
          :class="{ 'phase-card--active': faseActivaIndex === i, 'phase-card--done': faseActivaIndex > i }"
        >
          <span class="phase-card__index">{{ i + 1 }}</span>
          <h3 class="phase-card__name">{{ fase.nombre }}</h3>
          <span class="phase-card__price">${{ fase.precio }}</span>
          <span class="phase-card__dates">{{ fase.fechas }}</span>
          <span v-if="faseActivaIndex === i" class="phase-card__badge">VIGENTE</span>
        </div>
      </div>

      <!-- <div class="companion-alert">
        <span class="companion-alert__icon" aria-hidden="true">👥</span>
        <div class="companion-alert__text">
          <span class="companion-alert__title">¿Llevas acompañante?</span>
          <span class="companion-alert__desc">Costo por persona <strong class="companion-alert__price">$150</strong></span>
        </div>
      </div> -->
      <div class="companion-alert">
        <span class="companion-alert__icon" aria-hidden="true">👥</span>
        <div class="companion-alert__text">
          <span class="companion-alert__title">¿Llevas acompañante?</span>
          <div class="companion-alert__prices">
            <span class="companion-alert__price-item">Solo el día del evento <strong>$150</strong>
              <small>/persona</small></span>
            <span class="companion-alert__price-item">Si se queda a acampar <strong>$250</strong>
              <small>/persona</small></span>
          </div>
        </div>
      </div>
    </section>

    <!-- ============ ENTREGA DE KIT + MENORES ============ -->
    <section class="logistics">
      <div class="logistics__grid">
        <div class="info-card">
          <span class="info-card__icon">📦</span>
          <h3>Entrega de kit</h3>
          <p class="info-card__big">12 de diciembre</p>
          <p>10:00 a.m. a 5:00 p.m.</p>
          <p class="info-card__ref">En las instalaciones de Las Cascadas. También puedes recogerlo el día del evento.</p>
        </div>

        <div class="info-card">
          <span class="info-card__icon">👨‍👩‍👧</span>
          <h3>Menores de edad</h3>
          <p>Deberán presentar una responsiva firmada por padre, madre o tutor.</p>
          <a href="https://wa.me/525540861907" target="_blank" class="info-card__link">Solicítala por WhatsApp &rarr;</a>
        </div>
      </div>
    </section>

    <!-- ============ SERVICIOS CON COSTO EXTRA (campamento) ============ -->
    <section class="camp">
      <div class="camp__wrap">
        <span class="tag tag--light">Quédate un poco más</span>
        <h2 class="camp__title">SERVICIOS CON COSTO EXTRA</h2>
        <p class="camp__text">
          Puedes llegar desde el 12 de diciembre y contratar directamente en el lugar:
        </p>
        <div class="chips chips--light">
          <span class="chip chip--light">Camping - $250 por persona</span>
          <span class="chip chip--light">Cabañas</span>
          <span class="chip chip--light">Hospedaje</span>
          <span class="chip chip--light">Restaurante</span>
          <span class="chip chip--light">Bar</span>
        </div>
        <p class="camp__note">⚠️ Estos servicios no están incluidos en la inscripción y tienen costo adicional.</p>
      </div>
    </section>

    <!-- ============ PUNTOS DE REGISTRO ============ -->
    <section class="points">
      <span class="tag tag--dark">Puntos de registro presencial</span>
      <div class="points__row">
        <div class="point" v-for="p in puntosRegistro" :key="p.nombre">
          <span class="point__pin">📍</span>
          <h3>{{ p.nombre }}</h3>
          <p>{{ p.direccion }}</p>
        </div>
      </div>
    </section>

    <!-- ============ FORMAS DE PAGO (reutilizado / restyled) ============ -->
    <section class="payment">
      <div class="payment__head">
        <h2 class="payment__title">INSCRIPCIONES</h2>
        <p class="payment__sub">Elige tu método preferido</p>
      </div>

      <div class="payment__row">

        <!-- Presencial -->
        <div class="pay-card">
          <span class="pay-card__badge">PRESENCIAL</span>
          <div class="text-center mb-4 mt-2">
            <img src="@/assets/images/logo_principal.png" class="logo-presencial" alt="logo">
          </div>
          <h3 class="pay-card__title">Gimnasio El Terreno</h3>
          <p class="pay-card__meta">Lunes a viernes</p>
          <p class="pay-card__highlight">5:00 PM a 8:00 PM</p>
          <p class="pay-card__note">Inscripción directa en el gimnasio, Canalejas, Jilotepec.</p>
        </div>

        <!-- Transferencia (destacada) -->
        <div class="pay-card pay-card--featured">
          <span class="pay-card__badge pay-card__badge--dark">EN LÍNEA</span>
          <h3 class="pay-card__title">Transferencia CLABE</h3>

          <div class="pay-card__code">
            <code>728969000028945078</code>
          </div>

          <div class="pay-card__cols">
            <div>
              <span class="pay-card__label">Banco</span>
              <p>Spin por OXXO</p>
            </div>
            <div>
              <span class="pay-card__label">Titular</span>
              <p>Xhindexi</p>
            </div>
          </div>

          <div class="pay-card__steps">
            <p><strong>1.</strong> Inicia tu registro aquí:</p>
            <button class="btn btn--dark pay-card__cta" type="button" @click="irARegistro" :disabled="inscripcionesCerradas">
              {{ inscripcionesCerradas ? 'REGISTRO FINALIZADO' : 'INSCRIBIRME' }}
            </button>
            <p class="pay-card__small">
              <strong>2.</strong> Envía tu comprobante y confirmación al
              <a href="https://wa.me/525540861907">55&nbsp;4086&nbsp;1907</a> para validar tu lugar.
            </p>
          </div>
        </div>

        <!-- OXXO -->
        <div class="pay-card">
          <span class="pay-card__badge pay-card__badge--oxxo">EFECTIVO OXXO</span>
          <h3 class="pay-card__title">Pago directo en OXXO</h3>

          <div class="pay-card__code pay-card__code--light">
            <span class="pay-card__label">Número para depósito</span>
            <code>2242 1704 2012 2648</code>
          </div>

          <ol class="pay-card__ordered">
            <li>Realiza tu pago en caja y guarda tu ticket.</li>
            <li>Inicia tu registro abajo y carga la foto del ticket.</li>
            <li>Envía tu comprobante y confirmación al <a href="https://wa.me/525540861907">55&nbsp;4086&nbsp;1907</a>.</li>
          </ol>

          <button class="btn btn--dark pay-card__cta" type="button" @click="irARegistro" :disabled="inscripcionesCerradas">
            {{ inscripcionesCerradas ? 'REGISTRO FINALIZADO' : 'INSCRIBIRME' }}
          </button>
        </div>

      </div>
    </section>

    <!-- ============ FOOTER ============ -->
    <footer class="footer">
      <span class="footer__brand">XHIDENXI</span>
      <p class="footer__contact">
        Informes, registros, comprobantes y responsivas &mdash;
        <a href="https://wa.me/525540861907">55&nbsp;40&nbsp;86&nbsp;19&nbsp;07</a>
      </p>
      <p class="footer__legal">Reto Entre Cascadas · 13 de diciembre de 2026 · Villa del Carbón, Edo. Méx.</p>
    </footer>

  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import router from '@/router'

const kitItems = [
  'Playera oficial',
  'Medalla',
  'Buff / cuello deportivo',
  'Número de corredor',
  'Acceso al lugar',
  'Acceso a senderos',
  'Áreas verdes',
  'Río',
  'Alberca',
  'Áreas deportivas',
  'Estacionamiento sin costo',
  'Baños sin costo',
  'Servicios médicos',
  'Hidratación',
  'Puente colgante'
]

const salidas = [
  { km: '5K', hora: '8:00 a.m.' },
  { km: '10K', hora: '8:10 a.m.' }
]

const puntosRegistro = [
  { nombre: 'Las Cascadas', direccion: 'Carretera Chapa – Villa del Carbón' },
  { nombre: 'Squisito', direccion: 'Frente al BBVA, Jilotepec Centro' },
  { nombre: 'Gimnasio El Terreno', direccion: 'Canalejas, Jilotepec' }
]

const fases = [
  { nombre: 'FASE 1', precio: '500', fechas: '1 – 30 de septiembre', inicio: new Date('2026-09-01'), fin: new Date('2026-09-30T23:59:59') },
  { nombre: 'FASE 2', precio: '600', fechas: '1 – 30 de octubre', inicio: new Date('2026-10-01'), fin: new Date('2026-10-30T23:59:59') },
  { nombre: 'FASE 3', precio: '700', fechas: '31 de octubre – 13 de diciembre', inicio: new Date('2026-10-31'), fin: new Date('2026-12-13T23:59:59') }
]

const FECHA_LIMITE = new Date('2026-12-13T23:59:59')
const ahora = ref(new Date())

const inscripcionesCerradas = computed(() => ahora.value >= FECHA_LIMITE)

const faseActivaIndex = computed(() => {
  const idx = fases.findIndex(f => ahora.value >= f.inicio && ahora.value <= f.fin)
  return idx === -1 ? (ahora.value < fases[0].inicio ? 0 : fases.length - 1) : idx
})

let timer
onMounted(() => {
  timer = setInterval(() => { ahora.value = new Date() }, 60000)
})
onUnmounted(() => clearInterval(timer))

const irARegistro = () => {
  if (inscripcionesCerradas.value) return
  router.push('/registro-reto-cascadas')
}

const openGoogleMaps = () => {
  window.open('https://maps.app.goo.gl/Kh9BFjXs27BP3ECj6?g_st=ic', '_blank')
}
</script>

<style setup>
/* ============================================================
   RETO ENTRE CASCADAS — Design tokens
   ============================================================ */
.cascadas {
  --forest-950: #0d1912;
  --forest-900: #12241a;
  --forest-800: #1b3527;
  --forest-700: #274c37;
  --moss-500: #7f9c5c;
  --moss-400: #a2bd82;
  --water-600: #2f5f66;
  --water-400: #6ba3aa;
  --paper-050: #faf7ee;
  --paper-100: #f1ead9;
  --ink-900: #14231a;
  --gold-500: #c9a04a;

  --font-display: 'Anton', 'Arial Narrow', sans-serif;
  --font-body: 'Inter', sans-serif;

  background: var(--paper-050);
  color: var(--ink-900);
  font-family: var(--font-body);
  overflow-x: hidden;
}

.cascadas :is(h1, h2, h3) { font-family: var(--font-display); font-weight: 400; margin: 0; }

/* ---------- shared bits ---------- */
.cascadas .tag {
  display: inline-block;
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  padding: 8px 18px;
  border-radius: 999px;
  margin-bottom: 18px;
}
.cascadas .tag--dark { background: var(--forest-950); color: var(--paper-100); }
.cascadas .tag--light { background: rgba(255,255,255,0.12); color: #fff; border: 1px solid rgba(255,255,255,0.25); }

.cascadas .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 2px solid transparent;
  border-radius: 999px;
  padding: 16px 34px;
  font-family: var(--font-body);
  font-weight: 800;
  letter-spacing: 1px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform .25s ease, background .25s ease, color .25s ease;
  text-decoration: none;
}
.cascadas .btn--dark { background: var(--forest-950); color: var(--paper-050); }
.cascadas .btn--dark:hover:not(:disabled) { transform: translateY(-3px); background: var(--forest-800); }
.cascadas .btn--dark:disabled { opacity: .5; cursor: not-allowed; transform: none; }
.cascadas .btn--outline-light { border-color: rgba(255,255,255,0.7); color: #fff; }
.cascadas .btn--outline-light:hover { background: #fff; color: var(--forest-950); transform: translateY(-3px); }

.cascadas .chips { display: flex; flex-wrap: wrap; gap: 12px; }
.cascadas .chip {
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.2);
  color: #fff;
  padding: 10px 20px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.85rem;
  letter-spacing: .5px;
}
.cascadas .chip--light { background: var(--paper-100); border-color: rgba(0,0,0,0.06); color: var(--forest-900); }

.cascadas .title-accent { font-size: clamp(1.8rem, 4vw, 2.6rem); letter-spacing: 1px; }
.cascadas .title-accent--light { color: #fff; }

/* ============================================================
   HERO
   ============================================================ */
.cascadas .hero {
  position: relative;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  padding: 3.5rem 1.5rem 5rem;
  background:
    radial-gradient(120% 90% at 50% 0%, rgba(127,156,92,0.18), transparent 60%),
    linear-gradient(180deg, var(--forest-900) 0%, var(--forest-950) 55%, #060b08 100%);
  overflow: hidden;
}

.cascadas .hero__bg { position: absolute; inset: 0; z-index: 0; }

/* Topographic contour lines — evocan curvas de nivel de un sendero de montaña */
.cascadas .hero__contour {
  position: absolute;
  inset: -10%;
  z-index: 1;
  opacity: 0.16;
  background-image:
    repeating-radial-gradient(circle at 20% 30%, transparent 0, transparent 38px, rgba(255,255,255,0.5) 39px, transparent 40px, transparent 78px),
    repeating-radial-gradient(circle at 85% 75%, transparent 0, transparent 46px, rgba(255,255,255,0.4) 47px, transparent 48px, transparent 94px);
  mix-blend-mode: overlay;
  pointer-events: none;
}

.cascadas .hero__vignette {
  position: absolute; inset: 0; z-index: 1;
  background: radial-gradient(80% 60% at 50% 40%, transparent 40%, rgba(6,11,8,0.75) 100%);
  pointer-events: none;
}

.cascadas .hero__frame {
  position: relative;
  z-index: 2;
  max-width: 640px;
  padding: 2.75rem 2rem;
  border: 1px solid rgba(255,255,255,0.35);
}
.cascadas .hero__frame::before,
.cascadas .hero__frame::after {
  content: '';
  position: absolute;
  width: 26px; height: 26px;
  border: 2px solid #fff;
}
.cascadas .hero__frame::before { top: -1px; left: -1px; border-right: none; border-bottom: none; }
.cascadas .hero__frame::after { bottom: -1px; right: -1px; border-left: none; border-top: none; }

.cascadas .hero__brand {
  display: block;
  font-family: var(--font-body);
  font-weight: 300;
  font-size: clamp(1.1rem, 2.4vw, 1.5rem);
  letter-spacing: 10px;
  margin-bottom: 1.75rem;
}

.cascadas .hero__stamp {
  position: relative;
  width: 108px; height: 108px;
  margin: 0 auto 1.75rem;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
}
.cascadas .hero__stamp-ring { position: absolute; inset: 0; }
.cascadas .hero__stamp-ring circle { fill: none; stroke: var(--moss-400); stroke-width: 1.5; stroke-dasharray: 4 5; }
.cascadas .hero__stamp-icon { width: 34px; height: 34px; fill: #fff; margin-bottom: 4px; }
.cascadas .hero__stamp-text {
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: var(--moss-400);
}

.cascadas .hero__title {
  font-size: clamp(2.6rem, 8vw, 4.4rem);
  line-height: 0.94;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 1.1rem;
}

.cascadas .hero__subtitle {
  font-family: var(--font-body);
  font-weight: 300;
  font-size: clamp(0.95rem, 2vw, 1.15rem);
  letter-spacing: .5px;
  color: var(--paper-100);
  margin: 0 0 2rem;
}

.cascadas .hero__meta {
  display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 14px;
  font-family: var(--font-body); font-weight: 800; letter-spacing: 2px; font-size: 0.85rem;
}
.cascadas .hero__date {
  border: 2px solid #fff; border-radius: 10px; padding: 8px 20px;
}
.cascadas .hero__divider { width: 26px; height: 1px; background: rgba(255,255,255,0.4); }
.cascadas .hero__place { font-weight: 400; letter-spacing: .5px; opacity: .85; text-transform: none; }

.cascadas .hero__scroll {
  position: absolute; bottom: 2rem; left: 50%; transform: translateX(-50%);
  z-index: 2;
  display: flex; flex-direction: column; align-items: center; gap: 6px;
  color: rgba(255,255,255,0.75);
  font-size: 0.75rem; letter-spacing: 1px;
  text-decoration: none;
}
.cascadas .hero__scroll svg { animation: bob 2s ease-in-out infinite; }
@keyframes bob { 0%,100% { transform: translateY(0);} 50% { transform: translateY(6px);} }

/* ============================================================
   MISSION
   ============================================================ */

.imgBanner {
  display: block;
  margin: 0 auto;
  max-width: 180px;
}

.cascadas .mission { padding: 2rem 1.5rem 2rem; text-align: center; }
.cascadas .mission__text {
  max-width: 620px; margin: 0 auto;
  font-size: clamp(1.05rem, 2.2vw, 1.3rem);
  font-weight: 400; line-height: 1.6;
  color: var(--forest-900);
}

/* ============================================================
   PERMIT CARD
   ============================================================ */
.cascadas .permit-wrap { padding: 2rem 1.5rem 5rem; display: flex; justify-content: center; }
.cascadas .permit {
  width: 100%; max-width: 780px;
  display: flex;
  background: var(--forest-950);
  color: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 30px 60px rgba(13,25,18,0.25);
}
.cascadas .permit__stub {
  flex: 0 0 130px;
  background: var(--moss-500);
  color: var(--forest-950);
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 4px; padding: 1.5rem 1rem;
  border-right: 2px dashed rgba(13,25,18,0.35);
  writing-mode: vertical-rl;
  text-orientation: mixed;
}
.cascadas .permit__stub-label { font-size: 0.7rem; letter-spacing: 2px; font-weight: 600; }
.cascadas .permit__stub-value { font-family: var(--font-display); font-size: 1.4rem; letter-spacing: 1px; }
.cascadas .permit__body { flex: 1; padding: 2.25rem 2rem; }
.cascadas .permit__title { font-size: clamp(1.3rem, 3vw, 1.7rem); letter-spacing: .5px; margin-bottom: 1.5rem; }
.cascadas .permit__grid {
  display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.25rem 1.5rem; margin: 0 0 2rem;
}
.cascadas .permit__item dt { font-size: 0.7rem; letter-spacing: 1.5px; text-transform: uppercase; color: var(--moss-400); margin-bottom: 4px; }
.cascadas .permit__item dd { margin: 0; font-weight: 700; font-size: 1rem; }
.cascadas .permit__cta { width: 100%; background: var(--paper-050); color: var(--forest-950); }
.cascadas .permit__cta:hover:not(:disabled) { background: var(--moss-400); }

/* ============================================================
   LOCATION
   ============================================================ */
.cascadas .location { background: var(--forest-950); color: #fff; padding: 6rem 1.5rem; }
.cascadas .location__wrap {
  max-width: 1100px; margin: 0 auto;
  display: grid; grid-template-columns: 1fr; gap: 2.5rem; align-items: center;
}
.cascadas .location__title { font-size: clamp(2rem, 5vw, 2.8rem); letter-spacing: 1px; margin-bottom: 2rem; }
.cascadas .location__details { display: flex; flex-direction: column; gap: 1.75rem; margin-bottom: 2.25rem; }
.cascadas .location__row h3 { font-family: var(--font-body); font-size: 0.75rem; letter-spacing: 2px; text-transform: uppercase; color: var(--moss-400); margin-bottom: 6px; font-weight: 700; }
.cascadas .location__row p { margin: 0; font-size: 1.2rem; font-weight: 600; }
.cascadas .location__ref { font-size: 0.95rem !important; font-weight: 400 !important; opacity: .7; margin-top: 4px !important; }

.cascadas .location__map-frame { position: relative; border-radius: 24px; overflow: hidden; cursor: pointer; border: 1px solid rgba(255,255,255,0.12); }
.cascadas .location__map-placeholder {
  height: 340px; display: flex; align-items: center; justify-content: center; text-align: center; padding: 2rem;
  background:
    linear-gradient(135deg, var(--forest-800), var(--water-600));
  color: rgba(255,255,255,0.8); font-size: 0.8rem; letter-spacing: 1.5px; font-weight: 700;
}
.cascadas .location__map-overlay {
  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
  background: rgba(13,25,18,0.55); opacity: 0; transition: opacity .3s ease;
}
.cascadas .location__map-overlay span { background: #fff; color: var(--forest-950); padding: 12px 24px; border-radius: 999px; font-weight: 800; font-size: 0.8rem; letter-spacing: 1px; }
.cascadas .location__map-frame:hover .location__map-overlay { opacity: 1; }

@media (min-width: 960px) {
  .cascadas .location__wrap { grid-template-columns: 1fr 1fr; gap: 4rem; }
}

/* ============================================================
   SALIDAS / MILE MARKERS
   ============================================================ */
.cascadas .starts { padding: 6rem 1.5rem; text-align: center; background: var(--paper-050); }
.cascadas .starts__row { display: flex; flex-wrap: wrap; justify-content: center; gap: 3rem; margin: 2.5rem 0 2rem; }
.cascadas .marker { display: flex; flex-direction: column; align-items: center; }
.cascadas .marker__post {
  width: 96px; height: 96px; border-radius: 50%;
  background: var(--forest-950);
  border: 3px solid var(--moss-500);
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 1rem;
}
.cascadas .marker__km { font-family: var(--font-display); color: #fff; font-size: 1.5rem; letter-spacing: 1px; }
.cascadas .marker__time { font-weight: 800; font-size: 1.15rem; color: var(--forest-900); }
.cascadas .marker__label { font-size: 0.7rem; letter-spacing: 2px; color: var(--moss-500); font-weight: 700; }
.cascadas .starts__note { max-width: 480px; margin: 0 auto; color: var(--forest-700); font-size: 0.95rem; }

/* ============================================================
   CATEGORIES + PRIZE SEAL
   ============================================================ */
.cascadas .prizes { background: var(--forest-900); padding: 6rem 1.5rem; }
.cascadas .prizes__wrap {
  max-width: 1000px; margin: 0 auto;
  display: grid; grid-template-columns: 1fr; gap: 3rem; align-items: center;
}
.cascadas .prizes__sub { color: var(--paper-100); opacity: .75; margin: -0.5rem 0 1.5rem; font-size: 0.95rem; }
.cascadas .prizes__foot { margin-top: 1.5rem; color: var(--paper-100); opacity: .85; font-size: 0.95rem; }

.cascadas .prizes__seal { position: relative; width: 210px; height: 210px; margin: 0 auto; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.cascadas .prizes__seal-ring { position: absolute; inset: 0; }
.cascadas .prizes__seal-ring circle { fill: none; stroke: var(--gold-500); stroke-width: 1.4; }
.cascadas .prizes__seal-ring circle:last-child { stroke-dasharray: 3 6; }
.cascadas .prizes__seal-amount { font-family: var(--font-display); color: #fff; font-size: 2.1rem; letter-spacing: 1px; }
.cascadas .prizes__seal-label { font-size: 0.75rem; letter-spacing: 1.5px; color: var(--gold-500); text-align: center; margin-top: 6px; font-weight: 700; }

@media (min-width: 860px) {
  .cascadas .prizes__wrap { grid-template-columns: 1fr auto; }
}

/* ============================================================
   KIT DEL CORREDOR — TICKET
   ============================================================ */
.cascadas .kit { padding: 6rem 1.5rem; text-align: center; }
.cascadas .kit__title { font-size: clamp(2rem, 5vw, 2.8rem); margin: 0.5rem 0 3rem; color: var(--forest-950); }

.cascadas .kit__ticket {
  position: relative;
  max-width: 900px; margin: 0 auto;
  background: #fff;
  border: 1px solid rgba(20,35,26,0.08);
  border-radius: 22px;
  padding: 3rem 2.5rem;
  box-shadow: 0 25px 55px rgba(20,35,26,0.08);
  text-align: left;
}
.cascadas .kit__ticket-notch {
  position: absolute; top: 50%; transform: translateY(-50%);
  width: 34px; height: 34px; border-radius: 50%; background: var(--paper-050);
}
.cascadas .kit__ticket-notch--left { left: -17px; }
.cascadas .kit__ticket-notch--right { right: -17px; }

.cascadas .kit__list {
  list-style: none; margin: 0; padding: 0;
  display: grid; grid-template-columns: 1fr; gap: 1rem 2rem;
}
.cascadas .kit__list li {
  display: flex; align-items: center; gap: 10px;
  font-weight: 600; font-size: 0.98rem; color: var(--ink-900);
}
.cascadas .kit__list svg { flex: none; color: var(--moss-500); }

@media (min-width: 640px) { .cascadas .kit__list { grid-template-columns: 1fr 1fr; } }
@media (min-width: 960px) { .cascadas .kit__list { grid-template-columns: 1fr 1fr 1fr; } }

/* ============================================================
   FASES DE INSCRIPCIÓN
   ============================================================ */
/* .cascadas .phases { background: var(--paper-100); padding: 6rem 1.5rem; text-align: center; }
.cascadas .phases__title { font-size: clamp(1.7rem, 4vw, 2.4rem); margin: 0.5rem 0 3rem; color: var(--forest-950); }
.cascadas .phases__row {
  max-width: 960px; margin: 0 auto;
  display: grid; grid-template-columns: 1fr; gap: 1.5rem;
}
@media (min-width: 780px) { .cascadas .phases__row { grid-template-columns: repeat(3, 1fr); } }

.cascadas .companion-alert {
  display: flex;
  align-items: center;
  gap: 1.1rem;
  max-width: 460px;
  margin: 2.5rem auto 0;
  background: var(--forest-950);
  color: #fff;
  text-align: left;
  border-radius: 18px;
  padding: 1.15rem 1.5rem;
  border: 1px solid rgba(201,160,74,0.45);
  box-shadow: 0 20px 40px rgba(13,25,18,0.2);
}
.cascadas .companion-alert__icon {
  flex: none;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--gold-500);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}
.cascadas .companion-alert__text { display: flex; flex-direction: column; gap: 3px; }
.cascadas .companion-alert__title { font-weight: 800; letter-spacing: 0.3px; font-size: 0.98rem; }
.cascadas .companion-alert__desc { font-size: 0.9rem; opacity: 0.85; }
.cascadas .companion-alert__price {
  font-family: var(--font-display);
  color: var(--gold-500);
  font-size: 1.2rem;
  letter-spacing: 0.5px;
  margin-left: 4px;
  opacity: 1;
}

@media (max-width: 480px) {
  .cascadas .companion-alert { padding: 1rem 1.15rem; gap: 0.85rem; }
  .cascadas .companion-alert__icon { width: 44px; height: 44px; font-size: 1.25rem; }
}

.cascadas .phase-card {
  position: relative;
  background: #fff;
  border: 2px solid transparent;
  border-radius: 18px;
  padding: 2.25rem 1.5rem 1.75rem;
  text-align: center;
  opacity: 0.55;
  transition: opacity .3s ease, transform .3s ease, border-color .3s ease;
}
.cascadas .phase-card--done { opacity: 0.4; }
.cascadas .phase-card--active {
  opacity: 1;
  border-color: var(--moss-500);
  transform: translateY(-6px);
  box-shadow: 0 20px 40px rgba(20,35,26,0.1);
}
.cascadas .phase-card__index {
  display: inline-flex; align-items: center; justify-content: center;
  width: 34px; height: 34px; border-radius: 50%;
  background: var(--forest-950); color: #fff;
  font-family: var(--font-display); font-size: 0.95rem;
  margin-bottom: 1rem;
}
.cascadas .phase-card__name { font-size: 1.15rem; letter-spacing: 1px; margin-bottom: 0.75rem; color: var(--forest-950); }
.cascadas .phase-card__price { display: block; font-family: var(--font-display); font-size: 2.4rem; color: var(--forest-950); }
.cascadas .phase-card__dates { display: block; font-size: 0.85rem; color: var(--forest-700); margin-top: 6px; }
.cascadas .phase-card__badge {
  position: absolute; top: -12px; left: 50%; transform: translateX(-50%);
  background: var(--moss-500); color: #fff; font-size: 0.65rem; font-weight: 800;
  letter-spacing: 1.5px; padding: 5px 14px; border-radius: 999px;
} */
 .cascadas .phases { background: var(--paper-100); padding: 6rem 1.5rem; text-align: center; }
.cascadas .phases__title { font-size: clamp(1.7rem, 4vw, 2.4rem); margin: 0.5rem 0 3rem; color: var(--forest-950); }
.cascadas .phases__row {
  max-width: 960px; margin: 0 auto;
  display: grid; grid-template-columns: 1fr; gap: 1.5rem;
}
@media (min-width: 780px) { .cascadas .phases__row { grid-template-columns: repeat(3, 1fr); } }

.cascadas .companion-alert {
  display: flex;
  align-items: center;
  gap: 1.1rem;
  max-width: 520px;
  margin: 2.5rem auto 0;
  background: var(--forest-950);
  color: #fff;
  text-align: left;
  border-radius: 18px;
  padding: 1.25rem 1.6rem;
  border: 1px solid rgba(201,160,74,0.45);
  box-shadow: 0 20px 40px rgba(13,25,18,0.2);
}
.cascadas .companion-alert__icon {
  flex: none;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--gold-500);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}
.cascadas .companion-alert__text { display: flex; flex-direction: column; gap: 8px; }
.cascadas .companion-alert__title { font-weight: 800; letter-spacing: 0.3px; font-size: 0.98rem; }
.cascadas .companion-alert__prices { display: flex; flex-direction: column; gap: 4px; }
.cascadas .companion-alert__price-item { font-size: 0.88rem; opacity: 0.9; }
.cascadas .companion-alert__price-item strong {
  font-family: var(--font-display);
  color: var(--gold-500);
  font-size: 1.05rem;
  letter-spacing: 0.5px;
  margin: 0 2px 0 6px;
}
.cascadas .companion-alert__price-item small { opacity: 0.7; font-size: 0.75rem; }

@media (max-width: 480px) {
  .cascadas .companion-alert { padding: 1rem 1.15rem; gap: 0.85rem; }
  .cascadas .companion-alert__icon { width: 44px; height: 44px; font-size: 1.25rem; }
}

.cascadas .phase-card {
  position: relative;
  background: #fff;
  border: 2px solid transparent;
  border-radius: 18px;
  padding: 2.25rem 1.5rem 1.75rem;
  text-align: center;
  opacity: 0.55;
  transition: opacity .3s ease, transform .3s ease, border-color .3s ease;
}
.cascadas .phase-card--done { opacity: 0.4; }
.cascadas .phase-card--active {
  opacity: 1;
  border-color: var(--moss-500);
  transform: translateY(-6px);
  box-shadow: 0 20px 40px rgba(20,35,26,0.1);
}
.cascadas .phase-card__index {
  display: inline-flex; align-items: center; justify-content: center;
  width: 34px; height: 34px; border-radius: 50%;
  background: var(--forest-950); color: #fff;
  font-family: var(--font-display); font-size: 0.95rem;
  margin-bottom: 1rem;
}
.cascadas .phase-card__name { font-size: 1.15rem; letter-spacing: 1px; margin-bottom: 0.75rem; color: var(--forest-950); }
.cascadas .phase-card__price { display: block; font-family: var(--font-display); font-size: 2.4rem; color: var(--forest-950); }
.cascadas .phase-card__dates { display: block; font-size: 0.85rem; color: var(--forest-700); margin-top: 6px; }
.cascadas .phase-card__badge {
  position: absolute; top: -12px; left: 50%; transform: translateX(-50%);
  background: var(--moss-500); color: #fff; font-size: 0.65rem; font-weight: 800;
  letter-spacing: 1.5px; padding: 5px 14px; border-radius: 999px;
}

/* ============================================================
   LOGISTICS (entrega de kit / menores)
   ============================================================ */
.cascadas .logistics { padding: 5rem 1.5rem; }
.cascadas .logistics__grid {
  max-width: 900px; margin: 0 auto;
  display: grid; grid-template-columns: 1fr; gap: 1.5rem;
}
@media (min-width: 720px) { .cascadas .logistics__grid { grid-template-columns: 1fr 1fr; } }

.cascadas .info-card {
  background: #fff; border-radius: 20px; padding: 2.25rem;
  border: 1px solid rgba(20,35,26,0.07);
  box-shadow: 0 15px 35px rgba(20,35,26,0.05);
}
.cascadas .info-card__icon { font-size: 1.6rem; }
.cascadas .info-card h3 { font-family: var(--font-body); font-weight: 800; font-size: 1.05rem; letter-spacing: .5px; margin: 0.75rem 0 0.75rem; color: var(--forest-950); }
.cascadas .info-card p { margin: 0 0 0.35rem; color: var(--ink-900); }
.cascadas .info-card__big { font-family: var(--font-display); font-size: 1.5rem; color: var(--forest-950); }
.cascadas .info-card__ref { font-size: 0.9rem; opacity: .7; margin-top: 0.75rem !important; }
.cascadas .info-card__link { display: inline-block; margin-top: 0.75rem; font-weight: 800; color: var(--water-600); text-decoration: none; }
.cascadas .info-card__link:hover { text-decoration: underline; }

/* ============================================================
   CAMP / SERVICIOS EXTRA
   ============================================================ */
.cascadas .camp {
  background:
    linear-gradient(180deg, var(--water-600) 0%, var(--forest-950) 100%);
  color: #fff; padding: 6rem 1.5rem; text-align: center;
}
.cascadas .camp__wrap { max-width: 640px; margin: 0 auto; }
.cascadas .camp__title { font-size: clamp(1.8rem, 4.5vw, 2.5rem); margin: 0.5rem 0 1.25rem; }
.cascadas .camp__text { color: var(--paper-100); opacity: .9; margin-bottom: 1.75rem; }
.cascadas .camp .chips { justify-content: center; margin-bottom: 1.75rem; }
.cascadas .camp__note { font-size: 0.85rem; opacity: .75; }

/* ============================================================
   PUNTOS DE REGISTRO
   ============================================================ */
.cascadas .points { padding: 6rem 1.5rem; text-align: center; }
.cascadas .points__row {
  max-width: 960px; margin: 2.5rem auto 0;
  display: grid; grid-template-columns: 1fr; gap: 1.5rem;
}
@media (min-width: 780px) { .cascadas .points__row { grid-template-columns: repeat(3, 1fr); } }
.cascadas .point {
  background: var(--paper-100); border-radius: 18px; padding: 2rem 1.5rem;
}
.cascadas .point__pin { font-size: 1.4rem; }
.cascadas .point h3 { font-family: var(--font-body); font-weight: 800; font-size: 1rem; margin: 0.75rem 0 0.4rem; color: var(--forest-950); }
.cascadas .point p { margin: 0; font-size: 0.9rem; color: var(--forest-700); }

/* ============================================================
   FORMAS DE PAGO
   ============================================================ */
.logo-presencial {
    height: 60px;
    width: auto;
    object-fit: contain;
}

.cascadas .payment { background: var(--paper-100); padding: 6rem 1.5rem; }
.cascadas .payment__head { text-align: center; margin-bottom: 3rem; }
.cascadas .payment__title { font-size: clamp(1.8rem, 4.5vw, 2.4rem); color: var(--forest-950); }
.cascadas .payment__sub { text-transform: uppercase; letter-spacing: 2px; font-size: 0.8rem; font-weight: 700; color: var(--forest-700); margin-top: 0.5rem; }

.cascadas .payment__row {
  max-width: 1100px; margin: 0 auto;
  display: grid; grid-template-columns: 1fr; gap: 1.75rem;
}
@media (min-width: 960px) { .cascadas .payment__row { grid-template-columns: repeat(3, 1fr); } }

.cascadas .pay-card {
  background: #fff; border-radius: 22px; padding: 2rem;
  border: 1px solid rgba(20,35,26,0.07);
  box-shadow: 0 15px 35px rgba(20,35,26,0.05);
  display: flex; flex-direction: column;
}
.cascadas .pay-card--featured { background: var(--forest-950); color: #fff; border-color: transparent; transform: translateY(-8px); box-shadow: 0 25px 55px rgba(13,25,18,0.25); }
.cascadas .pay-card--featured .pay-card__label { color: var(--moss-400); }
.cascadas .pay-card--featured a { color: var(--moss-400); }

.cascadas .pay-card__badge {
  align-self: flex-start;
  background: var(--paper-100); color: var(--forest-950);
  font-size: 0.68rem; font-weight: 800; letter-spacing: 1.5px;
  padding: 6px 14px; border-radius: 999px; margin-bottom: 1.25rem;
}
.cascadas .pay-card__badge--dark { background: var(--moss-500); color: var(--forest-950); }
.cascadas .pay-card__badge--oxxo { background: #fce38a; color: #7a5b00; }

.cascadas .pay-card__title { font-family: var(--font-body); font-weight: 800; font-size: 1.1rem; text-align: center; margin-bottom: 1rem; }
.cascadas .pay-card__meta { text-align: center; font-size: 0.8rem; text-transform: uppercase; letter-spacing: 1px; opacity: .6; margin: 0 0 0.5rem; }
.cascadas .pay-card__highlight { text-align: center; font-weight: 800; background: var(--paper-050); border-radius: 12px; padding: 10px; margin-bottom: 0.75rem; }
.cascadas .pay-card__note { text-align: center; font-size: 0.85rem; opacity: .7; }

.cascadas .pay-card__code {
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 12px; padding: 12px; text-align: center; margin-bottom: 1.25rem;
}
.cascadas .pay-card__code code { font-size: 1.05rem; font-weight: 800; letter-spacing: .5px; }
.cascadas .pay-card__code--light { background: var(--paper-050); border-color: rgba(20,35,26,0.08); display: flex; flex-direction: column; gap: 6px; }
.cascadas .pay-card__code--light code { color: var(--forest-950); }

.cascadas .pay-card__cols { display: flex; justify-content: space-between; margin-bottom: 1.25rem; font-size: 0.9rem; }
.cascadas .pay-card__cols div:last-child { text-align: right; }
.cascadas .pay-card__cols p { margin: 2px 0 0; font-weight: 700; }
.cascadas .pay-card__label { font-size: 0.68rem; letter-spacing: 1px; text-transform: uppercase; opacity: .6; }

.cascadas .pay-card__steps { background: rgba(255,255,255,0.06); border-radius: 14px; padding: 1.25rem; text-align: center; }
.cascadas .pay-card__cta { width: 100%; margin: 0.75rem 0; background: var(--paper-050); color: var(--forest-950); }
.cascadas .pay-card__cta:hover:not(:disabled) { background: var(--moss-400); }
.cascadas .pay-card__small { font-size: 0.8rem; opacity: .75; margin: 0; }
.cascadas .pay-card__small a { color: var(--moss-400); font-weight: 700; }

.cascadas .pay-card__ordered { padding-left: 1.15rem; font-size: 0.88rem; color: var(--ink-900); margin: 0 0 1.25rem; display: flex; flex-direction: column; gap: 0.6rem; }
.cascadas .pay-card__ordered a { color: var(--water-600); font-weight: 700; }

.cascadas .pay-card a { text-decoration: none; }
.cascadas .pay-card a:hover { text-decoration: underline; }

/* ============================================================
   FOOTER
   ============================================================ */
.cascadas .footer { background: var(--forest-950); color: var(--paper-100); text-align: center; padding: 3.5rem 1.5rem; }
.cascadas .footer__brand { display: block; letter-spacing: 8px; font-weight: 300; margin-bottom: 1rem; }
.cascadas .footer__contact { margin: 0 0 0.5rem; font-size: 0.95rem; }
.cascadas .footer__contact a { color: var(--moss-400); font-weight: 700; text-decoration: none; }
.cascadas .footer__legal { font-size: 0.78rem; opacity: .5; margin: 0; }

/* ============================================================
   RESPONSIVE — mobile refinements
   ============================================================ */
@media (max-width: 640px) {
  .cascadas .permit { flex-direction: column; }
  .cascadas .permit__stub { flex-direction: row; writing-mode: horizontal-tb; border-right: none; border-bottom: 2px dashed rgba(13,25,18,0.35); gap: 8px; padding: 1rem; }
  .cascadas .permit__grid { grid-template-columns: 1fr; }
  .cascadas .location__row, .cascadas .location { text-align: left; }
  .cascadas .location__title { text-align: center; }
  .cascadas .btn--outline-light { width: 100%; }
  .cascadas .prizes__categories { text-align: center; }
  .cascadas .prizes__categories .chips { justify-content: center; }
}
</style>
